export const removeNullProperties = (objectElement) => {
  Object.keys(objectElement).forEach((key) => {
    if (objectElement[key] === null) {
      delete objectElement[key];
    }
  });
  return objectElement;
};

export const joinObjects = (rootElement, objectToJoin) => {
  Object.keys(objectToJoin).forEach((key) => {
    rootElement[key] = objectToJoin[key];
  });
  return rootElement;
};

export const objectIsEmpty = (objectElement) => {
  if (!objectElement || objectElement === null) return true;

  return Object.keys(objectElement).length === 0;
};
